import { render } from "./process-create.vue?vue&type=template&id=73dca5af"
import script from "./process-create.vue?vue&type=script&lang=js"
export * from "./process-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__